<template>
    <div
        class="widg_product"
        flex="|"
    >
        <div
            class="widg_product__header"
            flex="-spaceBetween"
        >
            <span>{{ $t('PtProduct.switch') }}</span>
            <a
                v-if="service.homeBtnVisible"
                class="widg_product__header-btn"
                :href="hrefHome"
            >{{ $t('PtProduct.mainPage') }} <PtIcon icon="SolidActionRight" /></a>
        </div>
        <ul
            class="widg_product__body"
            flex="-"
        >
            <li
                v-for="(product, index) in products"
                :key="index"
                class="patsnap-biz-product"
                @click="onCLick(product)"
            >
                <a
                    href="javascript: void 0;"
                    rel="noopener"
                    class="patsnap-biz-product__content"
                >
                    <PtIcon
                        class="patsnap-biz-product__icon"
                        :icon="product.icon"
                    />
                    <span class="patsnap-biz-product__text">{{ $t(product.label) }}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import '@cores/components/products.icons';
import Icon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/ActionRight.svg';
import { Site, SLD } from '@patsnap-utils/biz';
import { $t, getLang } from '@/locales';
import { map } from 'lodash';
export default {
    name: 'PtProduct',
    components: {
        PtIcon: Icon,
    },
    inject: ['mfeProps'],
    props: {
        service: {
            type: Object,
            required: true,
        },
    },
    created() {
        this.hrefHome = new Site({ sld: SLD.HOME });
    },
    computed: {
        isCn() {
            return getLang() === 'cn' || getLang() === 'tw';
        },
        products() {
            return map(this.service.products, item => {
                if (!this.isCn && item.key === 'eureka') {
                    return {
                        ...item,
                        icon: `${item.icon}En`,
                    };
                }
                return {
                    ...item,
                };
            });
        },
    },
    methods: {
        $t: $t,
        onCLick(product) {
            if (this.mfeProps.beforeJumpToProduct) {
                this.mfeProps.beforeJumpToProduct(product);
            } else {
                if (product.href) {
                    window.open(product.href, '_blank');
                }
            }
        },
    },
};
</script>
<style lang="scss">

.widg_product {
    width: 360px;
    padding: 16px 16px 8px;
    font-size: 14px;
    color: $text-primary;

    .widg_product__header {
        margin-bottom: 16px;
        font-size: 16px;
    }

    .widg_product__header-btn {
        color: $status-info-primary;
        font-weight: bold;
        cursor: pointer;
        text-decoration: none;
        font-size: 14px;

        .patsnap-biz-icon {
            color: $status-info-primary;
            font-size: 24px;
        }
    }

    .widg_product__body {
        flex-wrap: wrap;
    }

    .patsnap-biz-product {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 104px;
        height: 76px;
        margin-right: 8px;
        margin-bottom: 16px;
        cursor: pointer;

        .patsnap-biz-product__content {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 8px;
            width: 100%;
            height: 100%;
            text-decoration: none;
            color: $text-primary;
            border-radius: 4px;

            &:hover {
                background-color: $bg-hover;
            }
            &:active {
                background-color: $bg-dark;
            }
        }

        &:nth-of-type(3n+3) {
            margin-right: 0;
        }

        &__text {
            margin-top: 8px;
            line-height: 20px;
            height: 20px;
        }

        &__icon {
            font-size: 32px;
        }
    }
}
</style>
